export * from './client';
export * from './types';
export * as home from './home';
export * as blog from './blog';
export * as casinos from './casinos';
export * as collections from './collections';
export * as bigwins from './bigwins';
export * as streamers from './streamers';
export * as slots from './slots';
export * as complaints from './complaints';
export * as questions from './questions';
export * as filters from './filters';
export * as variables from './variables';
export * as providers from './providers';
export * as publicationComments from './publication-comments';

import * as home from './home';
import * as blog from './blog';
import * as casinos from './casinos';
import * as collections from './collections';
import * as bigwins from './bigwins';
import * as streamers from './streamers';
import * as slots from './slots';
import * as complaints from './complaints';
import * as questions from './questions';
import * as filters from './filters';
import * as variables from './variables';
import * as providers from './providers';
import * as publicationComments from './publication-comments';

export const api = {
  home,
  blog,
  casinos,
  collections,
  bigwins,
  streamers,
  slots,
  complaints,
  questions,
  filters,
  variables,
  providers,
  publicationComments,
};
